import { Box, Typography, Button, Stack, Card, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useParams, useLocation, useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';
import { trackRegistrationComplete, trackPurchase } from '../../../shared/analytics/gtm';
import type { TrackableEvent } from '../../../shared/analytics/types';

interface PublicEventOutletContext {
    event: TrackableEvent;
}

export default function RegistrationSuccessPage() {
    const navigate = useNavigate();
    const { id, slug } = useParams();
    const location = useLocation();
    const theme = useTheme();
    const { event } = useOutletContext<PublicEventOutletContext>();

    const basePath = slug ? `/evento/${slug}` : `/public/event/${id}`;
    const successState = location.state as {
        paymentMethod?: string;
        transactionId?: string;
        value?: number;
    } | null;
    const paymentMethod = successState?.paymentMethod;
    const transactionId = successState?.transactionId;
    const value = successState?.value;

    useEffect(() => {
        if (event) {
            trackRegistrationComplete(event, paymentMethod, value, transactionId);
            if (paymentMethod === 'card') {
                trackPurchase(event, 'card', value, transactionId);
            }
        }
    }, [event, paymentMethod, value, transactionId]);

    const handleNewRegistration = () => {
        navigate(basePath);
    };

    return (
        <Box sx={{ p: { xs: 1, md: 4 }, background: theme.palette.background.default, minHeight: '100vh' }}>
            <Card sx={{
                background: theme.palette.background.paper,
                borderRadius: 4,
                p: 4,
                maxWidth: 600,
                margin: '32px auto',
                boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)',
                textAlign: 'center'
            }}>
                <Stack alignItems="center" spacing={3} sx={{ py: 6 }}>
                    <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
                    <Typography variant="h4" fontWeight={700} color="success.main">
                        Inscrição realizada com sucesso!
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 500, textAlign: 'center' }}>
                        Parabéns! Sua inscrição foi processada com sucesso. Em breve você receberá mais informações sobre o evento.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ mt: 4, px: 4, py: 1.5 }}
                        onClick={handleNewRegistration}
                    >
                        Fazer nova inscrição
                    </Button>
                </Stack>
            </Card>
        </Box>
    );
}
